/* eslint-disable */

<template>
  <div>
    <div style="width: 75%; margin: 0 auto">
      <!-- ── Graphic banner with clickable circle overlays ── -->
      <div style="position: relative" class="mb-8">
        <img
          src="https://ip-learn.b-cdn.net/simulations/kill-chain-attack-mapping/graphic.png"
          style="width: 100%; display: block; border-radius: 8px"
          alt=""
          draggable="false"
        />
        <!-- Circle overlays — positions are % of container width/height so they stay fixed on zoom -->
        <div
          v-for="circle in circles"
          :key="circle.key"
          :style="circle.style"
          style="position: absolute; border-radius: 50%; cursor: pointer; transition: background 0.15s"
          :class="hoveredCircle === circle.key ? 'circle-hover' : 'circle-idle'"
          @click="openCircle(circle.key)"
          @mouseenter="hoveredCircle = circle.key"
          @mouseleave="hoveredCircle = null"
        />
      </div>

      <!-- ── Bottom row: Kill chain + Identify ── -->
      <div class="vx-row">
        <!-- Kill chain item -->
        <div class="vx-col lg:w-7/12 w-full">
          <vx-card>
            <h4 class="font-semibold mb-4 main-bottom-border pb-4">Kill chain item</h4>
            <div class="vx-row">
              <!-- Left sub-column -->
              <div class="vx-col w-6/12">
                <div v-for="item in killChainLeft" :key="item.key" class="mb-4">
                  <p class="font-medium mb-2" style="font-size: 0.9em">{{ item.label }}</p>
                  <div :style="selectStyle(item.answer, item.correct, gradedKillChain)">
                    <v-select v-model="item.answer" :options="killChainOptions" placeholder="Select option" />
                  </div>
                </div>
              </div>

              <!-- Right sub-column -->
              <div class="vx-col w-6/12">
                <div v-for="item in killChainRight" :key="item.key" class="mb-4">
                  <p class="font-medium mb-2" style="font-size: 0.9em">{{ item.label }}</p>
                  <div :style="selectStyle(item.answer, item.correct, gradedKillChain)">
                    <v-select v-model="item.answer" :options="killChainOptions" placeholder="Select option" />
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>

        <!-- Identify the following -->
        <div class="vx-col lg:w-5/12 w-full">
          <vx-card>
            <h4 class="font-semibold mb-4 main-bottom-border pb-4">Identify the following:</h4>

            <div class="mb-4">
              <p class="font-medium mb-2" style="font-size: 0.9em">Malicious executable</p>
              <div :style="selectStyle(maliciousExec, correctExec, gradedIdentify)">
                <v-select v-model="maliciousExec" :options="execOptions" placeholder="Select option" />
              </div>
            </div>

            <div class="mb-4">
              <p class="font-medium mb-2" style="font-size: 0.9em">Malicious IP address</p>
              <div :style="selectStyle(maliciousIP, correctIP, gradedIdentify)">
                <v-select v-model="maliciousIP" :options="ipOptions" placeholder="Select option" />
              </div>
            </div>

            <div class="mb-4">
              <p class="font-medium mb-2" style="font-size: 0.9em">Date/time malware entered organization</p>
              <div :style="selectStyle(malwareDate, correctDate, gradedIdentify)">
                <v-select v-model="malwareDate" :options="dateOptions" placeholder="Select option" />
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <!-- end 75% container -->

    <!-- ── Movable popup ── -->
    <movable-popup
      refVal="killChainPopup"
      :title="activeCircleData ? activeCircleData.title : ''"
      :width="activeCircle === 'fim' ? '82vw' : '62vw'"
      :active="circlePopupActive"
      v-on:close="circlePopupActive = false"
      padding="0"
    >
      <template v-slot:content>
        <div v-if="activeCircle === 'phishing'" style="padding: 24px; font-size: 0.9em">
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 16px">
            <tr>
              <td style="padding: 4px 12px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">From:</td>
              <td style="padding: 4px 0">IT HelpDesk &lt;it-helpdesk@company.com&gt;</td>
            </tr>
            <tr>
              <td style="padding: 4px 12px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Sent:</td>
              <td style="padding: 4px 0">Sun 12/01/2019 2:00:00</td>
            </tr>
            <tr>
              <td style="padding: 4px 12px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">To:</td>
              <td style="padding: 4px 0">Global Users &lt;globalusers@company.com&gt;</td>
            </tr>
            <tr>
              <td style="padding: 4px 12px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Subject:</td>
              <td style="padding: 4px 0">Moving our mail servers</td>
            </tr>
          </table>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin-bottom: 16px" />
          <p style="margin-bottom: 12px">Hi,</p>
          <p style="margin-bottom: 12px">
            In the upcoming days, we will be moving our mail servers. Check out the new Company Webmail to know if it has started working
            for you.
          </p>
          <p style="margin-bottom: 4px">Visit the new Company Webmail to see all the new features.</p>
          <p style="margin-bottom: 12px">
            Use your current username and password at <a href="#" style="color: #0053ff">Company Webmail</a>.
          </p>
          <p>For more details, visit our client located <a href="#" style="color: #0053ff">here</a>.</p>
        </div>

        <div v-else-if="activeCircle === 'firewall'" style="padding: 24px; font-size: 0.88em; font-family: 'Courier New', monospace">
          <p style="font-weight: 700; margin-bottom: 8px; font-family: sans-serif">Traffic denied:</p>
          <p style="margin-bottom: 16px; line-height: 1.6">
            Dec&nbsp;&nbsp;1 14:10:46 firewall0 firewall: NetScreen device_id=fire00 [Root]system-notification-00257(traffic): policy_id=119
            service=udp/port:7001 proto=17 src_zone=Trust dst_zone=Untrust action=Deny sent=0 rcvd=0 src=192.168.2.1 dst=1.2.3.4
            src_port=3036 dst_port=7001
          </p>
          <p style="margin-bottom: 16px; line-height: 1.6">
            Dec&nbsp;&nbsp;1 14:12:31 firewall0 firewall: NetScreen device_id=fire00 [Root]system-notification-00257(traffic): policy_id=120
            service=udp/port:20721 proto=17 src_zone=Trust dst_zone=DMZ action=Deny sent=0 rcvd=0 src=192.168.2.2 dst=1.2.3.4 src_port=53
            dst_port=20721
          </p>
          <p style="margin-bottom: 24px; line-height: 1.6">
            Dec&nbsp;&nbsp;1 14:14:31 firewall0 firewall: NetScreen device_id=fire00 [Root]system-notification-00257(traffic): policy_id=120
            service=udp/port:17210 proto=17 src_zone=Trust dst_zone=DMZ action=Deny sent=0 rcvd=0 src=192.168.2.2 dst=1.2.3.4 src_port=53
            dst_port=17210
          </p>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin-bottom: 16px" />
          <p style="font-weight: 700; margin-bottom: 8px; font-family: sans-serif">Alert message:</p>
          <p style="line-height: 1.6">
            Dec&nbsp;&nbsp;1 14:16:49 firewall0 firewall: NetScreen device_id=ns5gt [Root]system-alert-00016: invoke.exe From 192.168.2.10
            (port: 5071, TCP) to 198.51.100.25 (port: 4444, TCP) In trust, int untrust). Occurred 1 times.
          </p>
        </div>

        <div v-else-if="activeCircle === 'fim'" style="font-size: 0.88em; overflow-x: auto">
          <p style="padding: 16px 16px 8px; color: #4a5568">
            Shows files, folders, shares, and permissions that were created, deleted, or modified.
          </p>
          <vs-table :data="fimRows" style="min-width: 700px">
            <template slot="thead">
              <vs-th style="min-width: 120px">Action</vs-th>
              <vs-th style="min-width: 100px">Object type</vs-th>
              <vs-th style="min-width: 280px">What</vs-th>
              <vs-th style="min-width: 160px">Who</vs-th>
              <vs-th style="min-width: 100px">When</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(row, i) in fimRows" :key="i" class="fim-row">
                <vs-td
                  ><span style="font-weight: 700">{{ row.action }}</span></vs-td
                >
                <vs-td>
                  {{ row.objectType }}
                  <div v-if="row.where" style="margin-top: 6px; font-size: 0.9em; opacity: 0.75">
                    Where: {{ row.where }}<br />Workstation: {{ row.workstation }}
                  </div>
                </vs-td>
                <vs-td style="font-family: monospace; font-size: 0.9em; word-break: break-all">{{ row.what }}</vs-td>
                <vs-td>{{ row.who }}</vs-td>
                <vs-td style="white-space: nowrap">{{ row.when }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div v-else-if="activeCircle === 'vuln'" style="padding: 24px; font-size: 0.88em">
          <div style="margin-bottom: 24px">
            <p style="color: #ea5455; font-weight: 700; margin-bottom: 12px">HIGH SEVERITY</p>
            <table style="width: 100%; border-collapse: collapse">
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top; width: 180px">Title:</td>
                <td style="padding: 4px 0">Cleartext transmission of sensitive information</td>
              </tr>
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Description:</td>
                <td style="padding: 4px 0">
                  The software transmits sensitive or security-critical data in Cleartext in a communication channel that can be sniffed by
                  authorized users.
                </td>
              </tr>
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Affected asset:</td>
                <td style="padding: 4px 0">172.30.0.150</td>
              </tr>
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Risk:</td>
                <td style="padding: 4px 0">
                  Anyone can read the information by gaining access to the channel being used for communication.
                </td>
              </tr>
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Reference:</td>
                <td style="padding: 4px 0">CVE-2002-1949</td>
              </tr>
            </table>
          </div>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin-bottom: 24px" />
          <div>
            <p style="color: #ea5455; font-weight: 700; margin-bottom: 12px">HIGH SEVERITY</p>
            <table style="width: 100%; border-collapse: collapse">
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top; width: 180px">Title:</td>
                <td style="padding: 4px 0">Elevated privileges not required for software installations</td>
              </tr>
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Description:</td>
                <td style="padding: 4px 0">
                  All account types can install software, requirements for privileged accounts for installation capabilities is not
                  configured.
                </td>
              </tr>
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Affected asset:</td>
                <td style="padding: 4px 0">172.30.0.152</td>
              </tr>
              <tr>
                <td style="padding: 4px 16px 4px 0; font-weight: 700; white-space: nowrap; vertical-align: top">Risk:</td>
                <td style="padding: 4px 0">Increased risk for unauthorized or malicious software installation</td>
              </tr>
            </table>
          </div>
        </div>

        <div v-else-if="activeCircle === 'malware'" style="padding: 24px; font-size: 0.88em">
          <p style="color: #4a5568">Malware domain list content — populate as needed.</p>
        </div>
      </template>
    </movable-popup>
  </div>
  <!-- end single root -->
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      gradedKillChain: false,
      gradedIdentify: false,

      circlePopupActive: false,
      activeCircle: null,
      hoveredCircle: null,

      circles: [
        {
          key: 'firewall',
          title: 'Firewall log',
          style: 'left:3.1%;top:9.5%;width:16%;aspect-ratio:1;',
        },
        {
          key: 'fim',
          title: 'File integrity monitoring report',
          style: 'left:22.1%;top:10%;width:16%;aspect-ratio:1;',
        },
        {
          key: 'malware',
          title: 'Malware domain list',
          style: 'left:41.15%;top:10%;width:16%;aspect-ratio:1;',
        },
        {
          key: 'vuln',
          title: 'Vulnerability scan report',
          style: 'left:60.2%;top:10%;width:16%;aspect-ratio:1;',
        },
        {
          key: 'phishing',
          title: 'Phishing email',
          style: 'left:79.25%;top:10%;width:16%;aspect-ratio:1;',
        },
      ],

      // Kill chain left column
      killChainLeft: [
        { key: 'phishing', label: 'Phishing email', answer: null, correct: 'Email filtering' },
        { key: 'links', label: 'Active links', answer: null, correct: 'VPN' },
        { key: 'website', label: 'Malicious website access', answer: null, correct: 'IP blocklist' },
        { key: 'download', label: 'Malware download', answer: null, correct: 'Firewall file type filter' },
      ],

      // Kill chain right column
      killChainRight: [
        { key: 'install', label: 'Malware install', answer: null, correct: 'Restricted local user permissions' },
        { key: 'execution', label: 'Malware execution', answer: null, correct: 'Updated antivirus' },
        { key: 'encryption', label: 'File encryption', answer: null, correct: 'Backups' },
      ],

      killChainOptions: [
        'Honeypot',
        'Email filtering',
        'Backups',
        'VPN',
        'MAC filtering',
        'MFA',
        'Disk-level encryption',
        'Network segmentation',
        'Updated antivirus',
        'Restricted local user permissions',
        'Firewall file type filter',
        'IP blocklist',
        'Plain text email format',
      ],

      // Identify the following
      maliciousExec: null,
      maliciousIP: null,
      malwareDate: null,

      correctExec: 'payroll.xlsx',
      correctIP: '81.161.63.103',
      correctDate: '1 Dec 2019 14:03:19',

      execOptions: ['Invoice.exe', 'rersume2.docx', 'payroll.xlsx', 'resume1.docx'],
      ipOptions: ['81.161.63.103', '171.25.193.25', '185.220.101.194', '10.1.1.238', '192.168.2.1', '81.161.63.253', '171.25.193.20'],
      fimRows: [
        {
          action: 'Added',
          objectType: 'File',
          what: '\\\\host1\\users\\user1\\Downloads\\payroll.xlsx',
          who: 'Domain\\users\\user1',
          when: '11/30/19 12:05:34',
          where: 'Host1',
          workstation: '172.30.0.152',
        },
        {
          action: 'Removed',
          objectType: 'File',
          what: '\\\\host1\\users\\user1\\Downloads\\payroll.xlsx',
          who: 'Domain\\users\\user1',
          when: '11/30/19 12:25:13',
          where: 'Host1',
          workstation: '172.30.0.152',
        },
        {
          action: 'Modified',
          objectType: 'File',
          what: '\\\\host1\\users\\user1\\Downloads\\resume1.docx',
          who: 'Domain\\users\\user1',
          when: '12/1/19 13:59:25',
          where: null,
          workstation: null,
        },
        {
          action: 'Modified',
          objectType: 'File',
          what: '\\\\host1\\users\\user1\\Downloads\\invoice.exe',
          who: 'Domain\\users\\user1',
          when: '12/1/19 14:03:55',
          where: null,
          workstation: null,
        },
      ],

      dateOptions: [
        '1 Dec 2019 14:03:19',
        '1 Dec 2019 13:59:25',
        '30 Nov 2019 12:05:34',
        '1 Dec 2019 14:03:55',
        '1 Dec 2019 11:24:16',
        '30 Nov 2019 12:25:13',
        '1 Dec 2019 14:25:30',
      ],
    };
  },

  computed: {
    activeCircleData() {
      return this.circles.find((c) => c.key === this.activeCircle) || null;
    },
    radioColor() {
      if (!this.gradedIdentify || !this.maliciousFile) return 'primary';
      return this.maliciousFile === this.correctFile ? 'success' : 'danger';
    },
  },

  watch: {
    killChainLeft: {
      deep: true,
      handler() {
        this.gradedKillChain = false;
      },
    },
    killChainRight: {
      deep: true,
      handler() {
        this.gradedKillChain = false;
      },
    },
    maliciousExec() {
      this.gradedIdentify = false;
    },
    maliciousIP() {
      this.gradedIdentify = false;
    },
    malwareDate() {
      this.gradedIdentify = false;
    },
  },

  methods: {
    openCircle(key) {
      this.activeCircle = key;
      this.circlePopupActive = true;
    },

    selectStyle(answer, correct, graded) {
      if (!graded || !answer) return 'border-radius: 4px;';
      if (answer === correct) return 'border-radius: 4px; box-shadow: 0 0 0 2px #28C76F;';
      return 'border-radius: 4px; box-shadow: 0 0 0 2px #EA5455;';
    },

    markSimulation() {
      let score = 0;
      this.gradedKillChain = true;
      this.gradedIdentify = true;

      [...this.killChainLeft, ...this.killChainRight].forEach((item) => {
        if (item.answer === item.correct) score++;
      });

      if (this.maliciousExec === this.correctExec) score++;
      if (this.maliciousIP === this.correctIP) score++;
      if (this.malwareDate === this.correctDate) score++;

      this.$emit('simulation_update_score', score);

      const max = this.killChainLeft.length + this.killChainRight.length + 3;
      if (score === max) return this.$emit('simulation_full_correct', score);
      this.$emit('simulation_getting_there', score);
    },
  },

  components: { vSelect, MovablePopup },

  props: {
    data: { type: Object, required: true },
  },
};
</script>

<style>
.circle-idle {
  background: transparent;
}
.circle-hover {
  background: rgba(0, 83, 255, 0.15);
  outline: 3px solid rgba(0, 83, 255, 0.5);
}

.fim-row td.vs-table--td {
  border-bottom: 1px solid rgba(128, 128, 128, 0.2) !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
</style>
